import { CountryCode, parsePhoneNumberFromString } from "libphonenumber-js";
import { SplitPhoneResult } from "./model";

/**
 * Separa o DDI do resto do telefone usando libphonenumber-js.
 *
 * @param rawPhone Número completo (com ou sem DDI), ex: "+55 41 99876-5432" ou "41998765432"
 * @param defaultCountry País padrão caso não venha com DDI (ex: 'BR')
 */
export function splitPhoneNumber(
  rawPhone?: string,
  defaultCountry: CountryCode = "BR",
): SplitPhoneResult {
  if (!rawPhone) {
    return {
      ddi: "+55",
      nationalNumber: undefined,
      country: undefined,
      e164: undefined,
    };
  }

  const phoneNumber = rawPhone.startsWith("+")
    ? parsePhoneNumberFromString(rawPhone)
    : parsePhoneNumberFromString(rawPhone, defaultCountry);

  const ddi = `+${phoneNumber?.countryCallingCode}`;
  const nationalNumber = phoneNumber?.nationalNumber;

  console.log(ddi, nationalNumber);

  return {
    ddi,
    nationalNumber,
    country: phoneNumber?.country,
    e164: phoneNumber?.number,
  };
}
